// extracted by mini-css-extract-plugin
export default {"container":"UserListManagement_container__DSymi"};